import Settings from 'configs/Settings';

import Request from '@hotmart/request';

Request.register(Settings.api.notification, {
  get: {
    'notification.customToken': '/token/:userAreaCode'
  },
  post: {
    'notification.push.subscribe': '/notification/subscribe'
  }
});
